import { INCOME } from '../evidence';
import { VAT_FILTERS } from './vatEvidenceFilters';
import { VAT_REGISTER_TYPE_FILTER } from './EvidenceVatRegisterTypeFilter';

export const KPIR_SALES_LISTING_FILTERS = {
  path: '/evidences/kpir-sales',
  filters: [
    ...VAT_FILTERS,
    VAT_REGISTER_TYPE_FILTER(INCOME),
  ],
};
